import React from 'react';
import { injectStoresV2 } from '../../../stores/injectStoresV2';
import { RoutingStore } from '../../../stores/RoutingStore';
import { CategoriesStore } from '../../../stores/CategoriesStore';
import { TemplatesStore } from '../../../stores/TemplatesStore';
import { RouteLocation } from '../../../stores/routes/createRoute';
import { WithTranslations, withTranslations } from '../../../../utils/withTranslations';
import { CategoryTagList } from './CategoryTagList/CategoryTagList';

interface SubCategoriesProps extends WithTranslations {
  categoriesStore: CategoriesStore;
  routingStore: RoutingStore;
  templatesStore: TemplatesStore;
  dataHook?: string;
}

const SubCategoriesCmp = (props: SubCategoriesProps) => {
  const { categoriesStore, dataHook, routingStore, t, templatesStore } = props;
  const { activeSubCategorySlug, locationBuilders } = routingStore;

  const currentCategorySlug = templatesStore.fetchParams?.categorySlug;
  const loadedCategorySlug = templatesStore.loadedFetchParams?.categorySlug;

  const categorySlug = currentCategorySlug || loadedCategorySlug;

  const category = categoriesStore.getCategoryBySlug(categorySlug);

  if (!category || !category.subCategories.length) {
    return null;
  }

  const categoryLocation: RouteLocation = locationBuilders.category({ categorySlug: category.name });

  const categories = [
    {
      title: t('subHeader.subCategories.all'),
      slug: category.name,
      location: categoryLocation,
      isActive: !activeSubCategorySlug,
      isAll: true,
    },
    ...category.subCategories.map((subCategory) => {
      const isActive = activeSubCategorySlug === subCategory.name;

      const location = locationBuilders.subCategory({
        categorySlug: category.name,
        subCategorySlug: subCategory.name,
      });

      return {
        title: subCategory.displayName,
        slug: subCategory.name,
        location,
        isActive,
      };
    }),
  ];

  return <CategoryTagList dataHook={dataHook} categories={categories} />;
};

export const SubCategories = withTranslations(
  injectStoresV2('routingStore', 'categoriesStore', 'templatesStore')(SubCategoriesCmp),
);
